import { APP_INITIAL, APP_NAME } from "@/app/texts";
import { cn } from "cn";

/**
 * El nombre del sistema con el distintivo de la marca: un cuadro con el
 * degradado de la guía (`bg-brand-gradient`) y el nombre en el color del
 * texto. El degradado no va en las letras: en claro, el cian y el verde dan
 * 2,7:1 y 2,1:1 sobre blanco, y el nombre tiene que leerse.
 */
export function BrandName({ className }: { className?: string }) {
  return (
    <span className={cn("flex items-center gap-2 font-semibold", className)}>
      <span
        aria-hidden
        className="grid size-5 shrink-0 place-items-center rounded-md bg-brand-gradient text-[0.7rem] leading-none font-bold text-primary-foreground shadow-xs"
      >
        {APP_INITIAL}
      </span>
      {APP_NAME}
    </span>
  );
}
